"use strict";
IREP.promo = (function () {
    var promo = "#bodyContent_ctl00_ctl00_rptPromo_divPromo_";
    var numberOfPromos = $("#bodyContent_ctl00_ctl00_hdnNumberOfPromos").val();
    var promoNoCurrentlyDisplaying = $("#bodyContent_ctl00_ctl00_hdnPromoCurrentlyDisplayed").val();

    //alert('no of promos: ' + numberOfPromos);
    //alert('promo displaying: ' + promoNoCurrentlyDisplaying);

    var init = function (options) {

        //hide all promos except the first one
        for (var x = 1; x <= numberOfPromos; x++) {
            $(promo + x).css('display', 'none');
        }

        $(".upArrow").click(function () {
            getPromo('next');
        });

        $(".downArrow").click(function () {
            getPromo('previous');
        });
    };

    var getPromo = function (direction) {

        if (direction === "previous") {
            if ((promoNoCurrentlyDisplaying - 1) > 0) {//don't go back if at first promo
                $(promo + (promoNoCurrentlyDisplaying - 1)).css('display', 'none');//hide current promo, subtract 1 for 0 based index;
                promoNoCurrentlyDisplaying--;
                $("#bodyContent_ctl00_ctl00_hdnPromoCurrentlyDisplayed").val(promoNoCurrentlyDisplaying);
                $(promo + (promoNoCurrentlyDisplaying - 1)).css('display', 'block');//show previous promo, subtract 1 for 0 based index;
            }
        }
        else {
            if ((promoNoCurrentlyDisplaying + 1) <= numberOfPromos) { //don't move forward if at last promo
                $(promo + (promoNoCurrentlyDisplaying - 1)).css('display', 'none');//hide current promo, subtract 1 for 0 based index;
                promoNoCurrentlyDisplaying++;
                $("#bodyContent_ctl00_ctl00_hdnPromoCurrentlyDisplayed").val(promoNoCurrentlyDisplaying);
                $(promo + (promoNoCurrentlyDisplaying - 1)).css('display', 'block');  //show next promo, subtract 1 for 0 based index
            }

        }

    };

    return {
        init: init
    };
})();